module.exports = __webpack_public_path__ + "img/9.1cab43bc.jpg";